export default __webpack_public_path__ + "static/media/settings.e802c0b0.svg";